import { useAuth0 } from '@auth0/auth0-react'
import * as Sentry from '@sentry/react'
import React, { useEffect } from 'react'

/**
 * Syncs the current Auth0 user's email to Sentry so it is attached to all events
 * (errors, transactions, replays). Clears user context when logged out.
 */
const SentryUserSync: React.FC = () => {
  const { user } = useAuth0()

  useEffect(() => {
    if (user?.email) {
      Sentry.setUser({ email: user.email })
    } else {
      Sentry.setUser(null)
    }
  }, [user?.email])

  return null
}

export default SentryUserSync
